export const fuelUnits = [{value:'litre',label:'litre'},{value:'mmBTU',label:'mmBTU'},{value:'tonnes',label:'tonnes'},{value:'not_applicable',label:'Not Applicable'}]
export function electronicFields(report) {
 const data=report.report_data || {}
 return {
  report_details: {...{installation_reference:'',owner_name:'',owner_address:'',telephone:'',fax:'',generation_type:''},...(data.details || {})},
  readings: report.readings.map(u=>({key:u.key,generator_name:u.generator_name || u.label || '',generation_kwh:u.generation_kwh ?? '',fuel_type:u.fuel_type || '',fuel_consumption:u.fuel_consumption ?? '',fuel_unit:u.fuel_unit || '',fuel_na_reason:u.fuel_na_reason || ''})),
  usage: data.usage && data.usage.length ? data.usage.map(u=>({...u})) : [{category:'',kwh:''}],
  designation:data.designation || '',declaration_accepted:false,
 }
}
export function displayNumber(value) { return Number(value || 0).toLocaleString('en-MY',{minimumFractionDigits:3,maximumFractionDigits:3}) }
export function previewTotals(readings,usage) {
 const gen=readings.reduce((a,u)=>a+(Number(u.generation_kwh)||0),0)
 const used=usage.reduce((a,u)=>a+(Number(u.kwh)||0),0)
 const fuel={};readings.forEach(u=>{if(['litre','mmBTU','tonnes'].includes(u.fuel_unit) && u.fuel_consumption!=='' && u.fuel_consumption!==null)fuel[u.fuel_unit]=(fuel[u.fuel_unit] || 0)+(Number(u.fuel_consumption)||0)})
 return {generation_kwh:gen,usage_kwh:used,difference_kwh:gen-used,fuel}
}
